export default __webpack_public_path__ + "static/media/Prompt-Bold.e1b4fbc6.ttf";